import Icon from '../components/Icon.vue';
Icon.register({
  'expand-alt': {
    width: 448,
    height: 512,
    paths: [{
      d: 'M212.7 315.3l-92.7 92.7 32.9 31c15.1 15.1 4.4 41-17 41h-112c-13.3 0-24-10.7-24-24v-112c0-21.4 25.8-32.1 40.9-17l31.1 33 92.7-92.7c6.2-6.2 16.4-6.2 22.6 0l25.4 25.4c6.2 6.2 6.2 16.4 0 22.6zM235.3 196.7l92.7-92.7-32.9-31c-15.1-15.1-4.4-41 17-41h112c13.3 0 24 10.7 24 24v112c0 21.4-25.8 32.1-40.9 17l-31.1-33-92.7 92.7c-6.2 6.2-16.4 6.2-22.6 0l-25.4-25.4c-6.2-6.2-6.2-16.4 0-22.6z'
    }]
  }
});